/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.div`
	min-height: 49px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: ${({fontSize}) => fontSize ? fontSize : '20px'};
	color: ${({textColor}) => textColor};
	width: ${({width}) => width ? width : '100%'};
	background-color: ${({color}) => color};
	padding: ${({padding}) => padding ? padding : '9px 14px 10px 28px'};
`;


// WEBPACK FOOTER //
// ./src/components/task/shop/header.js